import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import {
  HiHome,
  HiUsers,
  HiArrowPath,
  HiUserPlus,
  HiDocumentPlus,
  HiEnvelope,
  HiMapPin,
  HiArrowRightOnRectangle,
  HiLockClosed,
  HiBuildingOffice2,
  HiBriefcase,
  HiKey,
  HiBuildingLibrary,
} from "react-icons/hi2";

import classes from "./Footer.module.css";
import approvedby1 from "../../images/validation1.png";
import approvedby2 from "../../images/validation2.png";
import { bankName, email, address } from "../../util/config";

const Footer = () => {
  const year = new Date().getFullYear();
  const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);

  return (
    <motion.footer
      className={classes.footer}
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
    >
      <div className={classes.inner}>
        <div className={classes.grid}>
          <div className={classes.brand}>
            <Link to="/" className={classes.brandLink}>
              <HiBuildingLibrary
                className={classes.brandLinkIcon}
                aria-hidden
              />
              {bankName}
            </Link>
            <p className={classes.eyebrow}>Administration</p>
            <p className={classes.tagline}>
              Manage accounts, transactions, and customer access from one secure
              control centre.
            </p>
          </div>

          <div className={classes.col}>
            <h2 className={classes.colTitle}>
              <HiBriefcase className={classes.colTitleIcon} aria-hidden />
              Workspace
            </h2>
            <nav className={classes.nav} aria-label="Admin navigation">
              <Link to="/">
                <HiHome className={classes.footerNavIcon} aria-hidden />
                Home
              </Link>
              <Link to="/accounts">
                <HiUsers className={classes.footerNavIcon} aria-hidden />
                Accounts
              </Link>
              <Link to="/transactions">
                <HiArrowPath className={classes.footerNavIcon} aria-hidden />
                Transactions
              </Link>
              <Link to="/createAccount">
                <HiUserPlus className={classes.footerNavIcon} aria-hidden />
                Create account
              </Link>
              <Link to="/createTransaction">
                <HiDocumentPlus className={classes.footerNavIcon} aria-hidden />
                Create transaction
              </Link>
            </nav>
          </div>

          <div className={classes.col}>
            <h2 className={classes.colTitle}>
              <HiEnvelope className={classes.colTitleIcon} aria-hidden />
              Contact
            </h2>
            <a className={classes.mail} href={`mailto:${email}`}>
              <HiEnvelope className={classes.mailIcon} aria-hidden />
              {email}
            </a>
            <address className={classes.address}>
              <HiMapPin className={classes.addressIcon} aria-hidden />
              <span>{address}</span>
            </address>
          </div>

          <div className={classes.col}>
            <h2 className={classes.colTitle}>
              <HiKey className={classes.colTitleIcon} aria-hidden />
              Access
            </h2>
            {isLoggedIn ? (
              <>
                <p className={classes.note}>
                  You are signed in. Use the menu or workspace links for day-to-day
                  tasks. For access issues, contact support via the email above.
                </p>
                <Link to="/accounts" className={classes.loginLink}>
                  <HiBuildingOffice2
                    className={classes.loginLinkIcon}
                    aria-hidden
                  />
                  Go to accounts
                </Link>
              </>
            ) : (
              <>
                <p className={classes.note}>
                  Sign in with your administrator credentials. For access issues,
                  contact the security team via the email above.
                </p>
                <Link to="/login" className={classes.loginLink}>
                  <HiArrowRightOnRectangle
                    className={classes.loginLinkIcon}
                    aria-hidden
                  />
                  Administrator sign in
                </Link>
              </>
            )}
          </div>
        </div>

        <div className={classes.badges}>
          <img src={approvedby1} alt="FSCS protection" />
          <img src={approvedby2} alt="BSI standards" />
        </div>

        <div className={classes.disclosure}>
          <p>
            {bankName} is authorised and regulated by the Swiss Financial
            Market Supervisory Authority (FINMA).
          </p>
          <p>
            {bankName} and {bankName} Investment Solutions are each authorised
            and regulated by FINMA.
          </p>
        </div>

        <p className={classes.copyright}>
          <HiLockClosed className={classes.copyrightIcon} aria-hidden />
          <span>© {year} {bankName}. All rights reserved.</span>
        </p>
      </div>
    </motion.footer>
  );
};

export default Footer;
